import React, { useContext, useEffect } from 'react';

import { ResearchContext } from '../../ResearchContext';


import {
    Autocomplete,
    Grid,
    TextField
} from '@mui/material';
import { SearchType } from "../../../../../helpers";


export function ComuneFilter() {

    const {

        state,

        isLoadingComuni,

        userComune,

        comuneFilter,
        setComuneFilter,

        isLoadingFilterFromCookies,
        setIsLoadingFilterFromCookies,
        handleWidgetSearchSubmit,

        activeSearchType,

    } = useContext(ResearchContext);

    const {
        comuniOptions,
    } = state;

    const filterOptions = (options, state) => {
        if (state.inputValue?.length > 0) {
            const optionsStartWith = options.filter(x => x.label.toLowerCase().startsWith(state.inputValue.toLowerCase())).sort((a, b) => a.label.length - b.label.length);
            const optionsContains = options.filter(x => x.label.toLowerCase().includes(state.inputValue.toLowerCase())).sort((a, b) => a.label.length - b.label.length);
            return [...optionsStartWith, ...optionsContains].filter((value, index, self) => {
                return self.indexOf(value) === index;
            })
        }
        return options
    }

    useEffect(() => {
        if (comuniOptions.length > 0 && userComune) {
            var comune = comuniOptions.filter(x => x.label.toLowerCase().startsWith(userComune.toLowerCase()))[0];
            if (comune) {
                setComuneFilter(comune.comuneId);

                handleWidgetSearchSubmit(comune.comuneId);
            }
        }
    }, [comuniOptions, userComune]);

    return activeSearchType === SearchType.Comune &&
        <Grid item xs={12} padding={1}>
            <Autocomplete
                disabled={isLoadingComuni}
                fullWidth
                options={comuniOptions}
                filterOptions={filterOptions}
                onChange={(e, value) => {
                    if (isLoadingFilterFromCookies) {
                        setIsLoadingFilterFromCookies(false);
                    }

                    setComuneFilter(value?.comuneId ?? "");
                }}
                value={comuniOptions.find(option => option.comuneId == comuneFilter) ?? null}
                renderInput={(params) => <TextField fullWidth {...params} label="Comune" placeholder='Seleziona il Comune' />}
            />
        </Grid>
}